export type ArticleStatus = 'draft' | 'published';

export interface Article {
    id: number;
    title: string;
    slug: string;
    excerpt?: string | null;
    coverImage?: string | null;
    status: ArticleStatus;
    publishedAt?: string | null;
    author: string;
    readingTime: number;
    createdAt?: string;
    updatedAt?: string;
    sections?: ArticleSection[];
}

export interface ArticleFigure {
    id?: number;
    sectionId?: number;
    order: number;
    imageUrl: string;
    caption?: string;
    altText?: string;
}

export interface ArticleSection {
    id?: number;
    articleId?: number;
    order: number;
    title: string;
    bodyMarkdown: string;
    bodyHtml?: string;
    figures?: ArticleFigure[];
}

export interface ArticleDTO {
    id: number;
    title: string;
    slug: string;
    excerpt?: string | null;
    coverImage?: string | null;
    status: "draft" | "published";
    publishedAt?: string | null;
    author: string;
    readingTime: number;
    createdAt?: string;
    updatedAt?: string;
}

export const toClientArticle = (dto: ArticleDTO): Article => ({
    id: dto.id,
    title: dto.title,
    slug: dto.slug,
    excerpt: dto.excerpt ?? null,
    coverImage: dto.coverImage ?? null,
    status: dto.status,
    publishedAt: dto.publishedAt ?? null,
    author: dto.author,
    readingTime: dto.readingTime,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
});
